import { useRouter } from 'next/router'
import { DARK_PAGES } from '@/components/constants'

// Components
import Navigation from '@/components/Navigation'
import FooterComponent from '@/components/Footer'

function DefaultLayout({ children }) {
  const { route } = useRouter()
  const isDark = DARK_PAGES.some((P) => P === route)

  // TODO: change pt-180 to pt-110 when removing investment banner
  return (
    <div>
      <div className="bg-white pt-110">
        <Navigation isDark={isDark} />
        <div className="m-30 max-w-[1280px] my-0 mx-auto rounded-20">
          {children}
        </div>
      </div>
      <FooterComponent sticky={false} />
    </div>
  )
}

export default DefaultLayout
